import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Button, Grid, makeStyles, Typography, useTheme } from '@material-ui/core';
import clsx from 'clsx';
import MigaPan from '../../../app/orussystem/component/MigaPan';
import Title from '../../Imc/Title';
import ChartDatos from './datos';
import CardPeso from './cardPeso/cardPeso';
import CardPresion from './cardPresion/cardPresion';
import CardTemp from './cardTemp/cardTemp';
import CardGrasa from './cardGrasa/cardGrasa';



import { getHistorico, getHistoricoDocumento } from '../../domain/api/UsersApi';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import CardBasal from './cardBasal/cardBasal';
import CardMusculoEsqueletico from './cardMusculoEsqueletico/cardMusculoEsqueletico';
import CardGrasaVisceral from './cardGrasaVisceral/cardGrasaVisceral';

const useStyles = makeStyles((theme) => {
    // Estilos
});

const HistorialUser = () => {
    const { documento, idBascula, nameBascula } = useParams();
    const history = useHistory();
    const classes = useStyles();
    const [isLoad, setisLoad] = useState(false);
    const [dataTableImc, setdataTableImc] = useState([]);
    const [dataTableIgc, setdataTableIgc] = useState([]);
    const [dataTablePresion, setdataTablePresion] = useState([]);
    const [dateTableOxi, setDateTableOxi] = useState([]);
    const [dateTableMetabolismo, setDateTableMetabolismo] = useState([]);

    const [lIcms, setLIcms] = useState([]);
    const [genero, setgenero] = useState([]);
    const location = useLocation();
    const { busqueda } = location.state
    const [peso, setPeso] = useState([]);
    const [dataHistoric, setDataHistoric] = useState([]);
    const [isError, setIsError] = useState(false); // Estado para el error de API
    const dispatch = useDispatch();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);


    const goBack = () => {
        const params = {
            nameBascula: nameBascula,
            busquedaState: busqueda
        }
        history.push(`/mediciones/user/${idBascula}`, params);
    };

    useEffect(() => {

        const fetchData = async () => {
            setisLoad(true);
            let userData;
            if (busqueda === "multifiltro") {
                userData = await getHistoricoDocumento(documento);
            } else {
                userData = await getHistorico(dispatch, documento, idBascula);
            }
            if (!userData || !userData.respuesta || userData.respuesta.respuesta === false) {
                setIsError(true);
            } else {
                setdataTableImc(userData.respuesta.imcs);
                setDataHistoric(userData.respuesta.user);
                setgenero(userData.respuesta.user[0]?.genero === undefined ? "" : userData.respuesta.user[0].genero)
                setPeso(userData.respuesta.user);
                setLIcms(userData.respuesta.imcs);
                setdataTablePresion(userData.respuesta.presiones);
                setdataTableIgc(userData.respuesta.igcs);
                setDateTableOxi(userData.respuesta.oximetrias);
                setDateTableMetabolismo(userData.respuesta.imcs);

                setisLoad(false);
            }
        };
        fetchData();
    }, [documento]);

    const theme = useTheme(); // Obtén el tema

    const primaryColor = theme.palette.primary.main;

    useEffect(() => {
        const handlePopstate = (event) => {
            const state = event.state;

            if (state && state.nameBascula && state.busquedaState) {

                const params = {
                    nameBascula: state.nameBascula,
                    busquedaState: state.busquedaState,
                };
                history.push(`/mediciones/user/${idBascula}`, params);
            }
        };

        window.addEventListener("popstate", handlePopstate);

        return () => {
            window.removeEventListener("popstate", handlePopstate);
        };
    }, [idBascula, history]);
    return (
        <>
            <Grid item xs={12}>
                <br />
                <br />
                <MigaPan
                    namePage="Historial usuarios"
                    to="/"
                    namePage2="Estaciones"
                    to2="/basculas/"
                    to3={{

                        pathname: `/mediciones/user/${idBascula}`,
                        state: { nameBascula: nameBascula, busquedaState: busqueda }, // Pass nameBascula in the state object
                    }}
                    namePage3={`Usuarios de Bascula ${nameBascula}`}
                >
                    Home
                </MigaPan>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
                <Title>Historial de mediciones</Title>
                {/* Verifica si hubo un error en la API */}
                {isError === true ? (
                    <Typography variant="body1" color="error">
                        no hay historial de mediciones para este usuario, actualice sus datos e intente nuevamente
                    </Typography>
                ) : (


                    <>
                        <ChartDatos data={dataHistoric} genero={genero} primaryColor={primaryColor} />
                        <CardPeso rows={dataTableImc} isLoad={isLoad} paperStyle={fixedHeightPaper} lIcms={lIcms} peso={peso} />
                        <CardPresion rows={dataTablePresion} isLoad={isLoad} paperStyle={fixedHeightPaper} lIcms={dataTablePresion} />
                        <CardGrasa rows={dataTableIgc} isLoad={isLoad} paperStyle={fixedHeightPaper} lIcgs={dataTableIgc} genero={genero} />
                        <CardTemp rows={dateTableOxi} isLoad={isLoad} paperStyle={fixedHeightPaper} lIcms={dateTableOxi} />
                        <CardBasal rows={dateTableMetabolismo} isLoad={isLoad} paperStyle={fixedHeightPaper} lIcms={dateTableMetabolismo}/>
                        <CardMusculoEsqueletico rows={dateTableMetabolismo} isLoad={isLoad} paperStyle={fixedHeightPaper} lIcms={dateTableMetabolismo}/>
                        <CardGrasaVisceral rows={dateTableMetabolismo} isLoad={isLoad} paperStyle={fixedHeightPaper} lIcms={dateTableMetabolismo}/>

                    </>


                )}
                <Button
                    variant="contained"
                    color="primary"
                    style={{ textTransform: "none", width: "100%", marginTop: 20 }}
                    onClick={goBack}
                >
                    Volver
                </Button>
            </Grid>
        </>
    );
};

export default HistorialUser;
